import { useAddCartItem } from '@/features/pos/components/Cart/hooks/useAddCartItem'
import { transformFormProductToCartItem } from '@/features/pos/components/Cart/utils/transforms'
import { Form } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { useConfigurableProductIdActions } from '@/features/pos/contexts/ConfigurableProductId'
import { useCallback } from 'react'

export const useConfirmProductConfiguration = (): ((form: Form) => Promise<void>) => {
    const { unset } = useConfigurableProductIdActions()

    const addCartItem = useAddCartItem()

    return useCallback(
        async (form: Form) => {
            const added = await addCartItem(transformFormProductToCartItem(form))

            if (added) unset()
        },
        [addCartItem, unset]
    )
}
